import { render, staticRenderFns } from "./withdrawRecord.vue?vue&type=template&id=2ec7de15&scoped=true&"
import script from "./withdrawRecord.vue?vue&type=script&lang=js&"
export * from "./withdrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./withdrawRecord.vue?vue&type=style&index=0&id=2ec7de15&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7de15",
  null
  
)

export default component.exports